import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import TutorialLauncher from "./TutorialLauncher";
import {
  buildEventsTutorialSteps,
  EVENTS_TUTORIAL_SEEN_KEY,
} from "./eventsTutorialConfig";

/**
 * Events tutorial for the player & team events pages. Thin wrapper that feeds the
 * shared TutorialLauncher the (localized) events step list and its persistence key.
 */
const EventsTutorial = ({ enabled = true }) => {
  const { t } = useTranslation();
  const steps = useMemo(() => buildEventsTutorialSteps(t), [t]);

  return (
    <TutorialLauncher
      steps={steps}
      storageKey={EVENTS_TUTORIAL_SEEN_KEY}
      enabled={enabled}
    />
  );
};

export default EventsTutorial;
